/* ショップ因子一覧検索フォーム */
import React from 'react';
import { useToggle } from '../hooks/ToggleHooks';
import { Button, Collapse, Row } from 'react-bootstrap';
import SearchSpan from '../molecules/SearchSpan';
import CheckBox from '../molecules/maintenance/CheckBox';
import { checkbox_brand_name_factor } from '../Const';
var StoreFactorSerchForm = function (_a) {
    var search_params = _a.search_params, handleChangeSearchParams = _a.handleChangeSearchParams, config = _a.config;
    // 検索条件表示フラグ
    var _b = useToggle(true), show = _b[0], toggleShow = _b[1];
    return (React.createElement("div", { id: "search" },
        React.createElement("div", { className: "hamburger-menu" },
            React.createElement("div", { className: "hamburger-menu-btn" },
                React.createElement(Button, { variant: "main-color", onClick: toggleShow },
                    React.createElement("span", { className: "triangle" }, show ? '▼' : '◀')))),
        React.createElement(Collapse, { className: "search-area", in: show },
            React.createElement("div", { className: "search-container" },
                React.createElement(Row, { className: "my-2" },
                    React.createElement(SearchSpan, { label: '販売店コード', value: config.shop_code }),
                    React.createElement(SearchSpan, { label: '営業グループ', value: config.sales_group }),
                    React.createElement(SearchSpan, { label: '担当セールス', value: config.sales_staff })),
                React.createElement(Row, { className: "my-2" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("span", { className: "search-criteria-head" }, "\u30B7\u30E7\u30C3\u30D7\u56E0\u5B50"),
                        React.createElement(CheckBox, { id: "factor-check-box", class_name: "factor-check-box", name: "factor", value: search_params.factor, handleChange: handleChangeSearchParams, sources: checkbox_brand_name_factor })))))));
};
export default StoreFactorSerchForm;
